import Image from "next/image";
import {Button} from "@mui/material";
import {useRouter} from "next/router";
import toast from "react-hot-toast";
import ToastComponent from "../ToastComponent";

const LogoButton = () => {
	const router = useRouter();
	const handleHomeClick = () => {
		router.push("/");
		// toast((t) => <ToastComponent/>, {duration: 50000});
	};
	return (
		<Button onClick={handleHomeClick} sx={{p: 1, width: "226px"}}>
			<Image
				src="/logo_full.png"
				alt="Logo"
				// initial size, to keep aspect ratio: w: 1280, h: 332
				width={182.8}
				height={47.4}
			/>
		</Button>
	);
};
export default LogoButton;
